import {Action} from '@ngrx/store';
import * as _ from 'lodash';
import {CreateAutomatiqueShippingSuccess, automatiqueShippingActionTypes} from '../actions/create-shipping';

export interface ShippingDHLsState {
  // tslint:disable-next-line:no-any
  array: any[];
}

const initialState: ShippingDHLsState = {
  array: []
};

export function ShippingsDHLReducer(state: ShippingDHLsState = initialState, action: Action): ShippingDHLsState {
  switch (action.type) {
    case automatiqueShippingActionTypes.ADD_SUCCESS:
      return handleLoadSuccessAction(state, action);
    case automatiqueShippingActionTypes.ADD_FAIL:
      return handleLoadFailAction(state);
    case automatiqueShippingActionTypes.REMOVE_CLEAR:
      return handleClearAllAction();
    default:
      return state;
  }
}

function handleLoadSuccessAction(state: ShippingDHLsState, action: CreateAutomatiqueShippingSuccess): ShippingDHLsState {
  const newState = _.clone(state);
  newState.array = action.payload;
  return newState;
}
function handleClearAllAction(): ShippingDHLsState {
  return initialState;
}
function handleLoadFailAction(state: ShippingDHLsState): ShippingDHLsState {
  const newState = _.clone(state);
  newState.array = [];
  return newState;
}

export const shippingsDHLSelectors = {
  array: (state: ShippingDHLsState) => _.get(state, 'array', [])
};
